import { render, staticRenderFns } from "./archves.vue?vue&type=template&id=38d3d9e8&scoped=true&"
import script from "./archves.vue?vue&type=script&lang=js&"
export * from "./archves.vue?vue&type=script&lang=js&"
import style0 from "./archves.vue?vue&type=style&index=0&id=38d3d9e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3d9e8",
  null
  
)

export default component.exports